import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { studentSlice, selectStudent } from "../../../redux/student/studentSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import StudentPageTitle from "../basics/StudentPageTitle";
import StudentPageAvatar from "../basics/StudentPageAvatar";
import { imageInsSlice } from "../../../redux/image/imageInsSlice";
import { ElementUploadImage } from "../../../features/base/image/ElementUploadImage";
import ElementSkeleton from "../../../features/base/ElementSkeleton";
import { useSearchParams } from "react-router-dom";
import { ObjectTarget } from "../../../app/permissions";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { assertThumbnailUrl } from "../../../redux/common";
import { TopBar } from "../../../features/top/TopBar";

export function StudentImage() {
    const student = useSelector(selectStudent);
    const dispatch = useAppDispatch();

    const {schoolId, studentId} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const source = searchParams.get("source");
    const classroomId = searchParams.get("classroomId");
    console.debug(`StudentImage: ${studentId}`);
    console.debug(`classroomId: ${classroomId}`);

    const breadcrumbTitle = "Alterar Imagem";
  
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const title = <StudentPageTitle studentId={studentId} />;
    const pageAvatar = <StudentPageAvatar />;
    if(!schoolId) {
      return <ElementMissingContext />;
    }

    let backTo = `/school/${schoolId}/student/${studentId}`;
    if(source == "Classroom") {
      backTo = `/school/${schoolId}/classroom/${classroomId}`;
    }
    if(source == "ClassroomStudentAdd") {
      backTo = `/school/${schoolId}/classroom/${classroomId}/student/add`;
    }

    const buildContent = () =>
      (student.selected)
      ? <ElementUploadImage 
            currentImage={assertThumbnailUrl(student.selected.url)}
            name={student.selected.name}
            backTo={backTo}
            target={{schoolId: schoolId, avatar: true, objectTarget: ObjectTarget.STUDENT, targetId: studentId!}}
            backCleanup={() => {
              dispatch(studentSlice.actions.clean());
              dispatch(imageInsSlice.actions.clean());
            }}
        />
      : <ElementSkeleton />;

    return <PageAuthenticatedLoading key="studentImage"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
            states: [student.state], 
            content: buildContent,
            error: "Erro ao carregar aluno",
            retry: () => {
            dispatch(studentSlice.actions.clean());
            },
        }} />;
                
}
